import * as React from 'react';

type Props = {
  fieldName: string;
  value: string;
};

export const FieldDisplay = (props: Props) => {
  return (
    <span className="bg-primary/10 text-primary flex h-5 shrink-0 items-center overflow-hidden rounded-md px-2 text-xs">
      <span className="font-medium">{props.fieldName}:</span>
      <span className="ml-1">{props.value}</span>
    </span>
  );
};
